import { render } from "./MainCommponent.vue?vue&type=template&id=5381ed03"
import script from "./MainCommponent.vue?vue&type=script&lang=js"
export * from "./MainCommponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__